import { render, staticRenderFns } from "./vehicleCuringList.vue?vue&type=template&id=2539b07b&scoped=true"
import script from "./vehicleCuringList.vue?vue&type=script&lang=js"
export * from "./vehicleCuringList.vue?vue&type=script&lang=js"
import style0 from "./vehicleCuringList.vue?vue&type=style&index=0&id=2539b07b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539b07b",
  null
  
)

export default component.exports